import {
  BEGIN_FETCH_SYMPHONY_SEARCH_COMPONENTS,
  FETCH_SYMPHONY_SEARCH_COMPONENTS_ERROR,
  RECEIVE_SYMPHONY_SEARCH_COMPONENTS
} from 'store/ducks/search/types';

const initialState = {
  error: null,
  isLoadingSymphony: false,
  symphony: {}
};

export default function searchReducer(state = initialState, action = {}) {
  const { type, payload } = action;
  switch (type) {
    case BEGIN_FETCH_SYMPHONY_SEARCH_COMPONENTS:
      return { ...state, isLoadingSymphony: true };
    case RECEIVE_SYMPHONY_SEARCH_COMPONENTS:
      return {
        ...state,
        isLoadingSymphony: false,
        symphony: payload.data
      };
    case FETCH_SYMPHONY_SEARCH_COMPONENTS_ERROR:
      // Clear the slot so a degraded fetch omits the supplementary search
      // region entirely rather than leaving stale data behind. Consumers read
      // `symphony.slotData` with optional chaining, so an empty slot renders
      // nothing (no broken placeholder).
      return { ...state, isLoadingSymphony: false, error: payload.error, symphony: {} };
    default:
      return state;
  }
}
